import './header'
import './accordion'
import './validate'
import './mask'
import './participants-slider'
import './rutube-slider'
import './universities-slider'
// import './modal'
import './tabs'
import './events-slider'
import './switcher'
import './infoSlider'
import './scienceSlider'
import './burger-menu'
import './select'
import './session-seminars'
import './showMore'
import './goverment-programs'
import './placeholder-animation'
import './tags-filter'
import './reviewsSlider'
import './modal-video'
import './form-modal'
import './dropdown-block'
import './copy-text'